import $ from 'jquery';
import defer from 'lodash/defer';

export default ({ multiple=true, accept }={})=> {
  const filesSelected = $.Deferred();

  const input = document.createElement('input');
  input.type = 'file';
  if (accept) {
    input.accept = accept.join(',');
  }
  input.multiple = multiple;
  input.onchange = ()=> {
    filesSelected.resolve(input.files);
  };
  defer(()=> {
    // A bit of a shot in the dark to try and prevent the occasional
    // error where after selecting a file the `onchange` event does not fire
    input.click();
  });

  return filesSelected.promise();
};